import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import lodash from 'lodash'
import BootstrapVue from 'bootstrap-vue'
import CKEditor from '@ckeditor/ckeditor5-vue';
import 'bootstrap-vue/dist/bootstrap-vue.css'
import '@/mixins';
import '@/vee-validate'
import VueMeta from 'vue-meta'
import LottieVuePlayer from "@lottiefiles/vue-lottie-player";

Vue.use(LottieVuePlayer);

Vue.use(VueMeta)

Vue.use(BootstrapVue)
Vue.prototype._ = lodash
Vue.use(CKEditor);

import OtpInput from "@bachdgvn/vue-otp-input";
Vue.component("v-otp-input", OtpInput);

import '@/helpers/common-components.js';
Vue.config.productionTip = false
const EventBus = new Vue()
Object.defineProperties(Vue.prototype, {
  $eventHub: {
    get: function () {
      return EventBus
    }
  }
})

// Vue.prototype.$eventHub = new Vue();
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app > div')
